import * as React from 'react';
//import { AppProps } from '../../components/app';
import PackageListingContainer from '../../components/package-listing-container';
import CartContainer from '../../components/cart/container';
import QuantitySelect from '../../components/cart/quantity-select';

import FiltersContainer from '../../components/filters/container';
import { AppProps } from '../../components/app';


class AppView extends React.Component<AppProps> {
    constructor(props) {
        super(props);
        this.state = {
            stickyInstance: null
        }
    }

    render() {
        return (
            <>
                {this.props.text.minimumPackagePerformanceQuantityMessage ?
                    <div className="ace-page-section"><p className="">
                        {this.props.text.minimumPackagePerformanceQuantityMessage}</p></div>
                    : null
                }
                {
                    this.props.settings.useUnseatedReservation ?
                        <div className="space-top-lg">
                            <QuantitySelect />
                        </div>
                        : null
                }
                <nav className="ace-filters-container space-top-lg stack-sm">
                    <div className="ace-block-inner">
                        <h2 className="ace-subs-filter-heading">{this.props.text.filtersTitle}</h2>
                    </div>
                    <FiltersContainer />
                </nav>
                <div className="ace-page-section">
                    <section className="ace-sidebar-page">
                        <div className="ace-sidebar-main ace-subs-listing">
                            <PackageListingContainer />
                        </div>
                        <div className="ace-sidebar ace-subs-sidebar" id="miniCart">
                            <CartContainer />
                        </div>
                    </section>
                </div>
            </>
        );
    }
}

export default AppView;